module.exports = "https://cdn.dove.it/_next/static/public/assets/living-room.9f7a9057fcf8c6337ac48640be6e51eb.jpg";